import Confirm from 'assets/components/page/templates/Confirm';
import ThemeConfirmDefault from 'assets/components/page/templates/themes/Theme.Confirm.Default';
import { getLocales } from 'assets/locales/Locale';
import React from 'react';
import { useVehicleClassProvider } from '../VehicleClass.Hooks';

export default function VehicleClassDelete() {
  const { lang } = getLocales();
  const { deleteApi, selected, pageRouter } = useVehicleClassProvider();

  return (
    <Confirm
      data={selected}
      onConfirm={({ id }) => deleteApi.execute(id)}
      onClose={pageRouter.updateParams}
      actionName={lang.delete}
      itemName={selected.primaryCode}
      confirmationType="nextButton"
      subcomponents={ThemeConfirmDefault}
    />
  );
}
